import { render, staticRenderFns } from "./feedback-detail.vue?vue&type=template&id=2ea26a62&scoped=true&"
import script from "./feedback-detail.vue?vue&type=script&lang=js&"
export * from "./feedback-detail.vue?vue&type=script&lang=js&"
import style0 from "./feedback-detail.vue?vue&type=style&index=0&id=2ea26a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea26a62",
  null
  
)

export default component.exports